export default __webpack_public_path__ + "d912cf08b66424046c0270fdc2868229.png";